export default {
    points: [
        { x: 3, y: 102.80 },
        { x: 4, y: 106.66 },
        { x: 5, y: 105.05 },
        { x: 6, y: 114.20 },
        { x: 7, y: 119.58 },
        { x: 8, y: 121.22 },
    ],
    yTicks: [0, 25, 50, 75, 100, 125, 150, 175, 200]
}